import {
  login,
  forgotPassword,
  startTrial,
  redirect,
  getCurrentUser,
  checkAvailability,
  checkServerAvailability,
} from './login'

// Assuming Cookies is still needed, we keep this import
import Cookies from 'universal-cookie'

const cookies = new Cookies()

function addClass(el, className) {
  el.classList.add(className)
}

function removeClass(el, className) {
  el.classList.remove(className)
}

function shake(el) {
  return new Promise<void>((resolve) => {
    addClass(el, 'animated')
    addClass(el, 'shake')
    setTimeout(() => {
      resolve()
    }, 1000)
  })
}

function unshake(el) {
  removeClass(el, 'animated')
  removeClass(el, 'shake')
}

document.addEventListener('DOMContentLoaded', () => {
  document
    .getElementById('RequestNewPassword')
    ?.addEventListener('click', function (e) {
      e.preventDefault()
      document
        .querySelector('#ForgotPassword')
        ?.dispatchEvent(new Event('submit'))
    })

  function showLoginError() {
    const alertElement = document.querySelector('#Login .alert')

    if (!alertElement) {
      return
    }
    alertElement.innerHTML = 'Benutzername oder Passwort ungültig.'
    alertElement.classList.remove('d-none')
    const lwindow = document.querySelector('.login-window')
    shake(lwindow).then(() => unshake(lwindow))
  }

  function showForgotPasswordAlert(status, message) {
    const lwindow = document.querySelector('.login-window')
    const alertElement = document.querySelector('#ForgotPassword .alert')
    if (!alertElement) {
      return
    }
    alertElement.innerHTML = message
    alertElement.className = 'alert alert-' + status
    if (status === 'danger') {
      shake(lwindow).then(() => unshake(lwindow))
    }
  }

  if (
    !cookies.get('blu-trial') &&
    window.location.host === 'interact.bluprevent.de'
  ) {
    getCurrentUser()
      .then(redirect)
      .catch(() => {
        /* User is not logged in */
      })
  }

  checkAvailability().catch(() => {
    checkServerAvailability()
      .then((response) => {
        response.text().then((data) => {
          document
            .querySelectorAll(
              '.login-form input, .login-form .btn, header .start-trial'
            )
            .forEach((elem) => (elem.style.display = 'none'))
          const alertElement = document.querySelector('.login-window .alert')
          if (!alertElement) {
            return
          }
          if (data === '200') {
            alertElement.innerHTML = `Ihr Netzwerk erfüllt leider nicht die Voraussetzungen, <a href="${document
              .querySelector('.menu-faq-link a')
              ?.getAttribute('href')}" class="text-danger">mehr im FAQ</a>.`
            alertElement.classList.remove('d-none')
          } else {
            alertElement.innerHTML =
              'Der Dienst ist momentan leider nicht erreichbar. Bitte versuchen Sie es später erneut.'
            alertElement.classList.remove('d-none')
          }
        })
      })
      .catch(() => {
        document
          .querySelectorAll('#Login input, #Login .btn, header .start-trial')
          .forEach((elem) => (elem.style.display = 'none'))
        const alertElement = document.querySelector('.login-window .alert')
        if (!alertElement) {
          return
        }
        alertElement.innerHTML =
          'Der Dienst ist momentan leider nicht erreichbar. Bitte versuchen Sie es später erneut.'
        alertElement.classList.remove('d-none')
      })
  })

  document
    .querySelector('#login-interact')
    ?.addEventListener('click', function (e) {
      e.preventDefault()
      document.querySelector('#Login')?.dispatchEvent(new Event('submit'))
    })

  document.querySelector('#Login')?.addEventListener('submit', function (e) {
    e.preventDefault()
    const username = this.querySelector('[name="username"]').value
    const password = this.querySelector('[name="password"]').value
    cookies.remove('blu-authorization-token', { path: '/' })
    cookies.remove('blu-trial', { path: '/' })
    login(username, password).then(redirect).catch(showLoginError)
  })

  document
    .querySelector('#ForgotPassword')
    ?.addEventListener('submit', function (e) {
      e.preventDefault()
      const email = document.getElementById('inputForgotPassword')?.value
      console.log(email)
      forgotPassword(email)
        .then((response) => {
          console.log(response)
          if (response.status === 200) {
            showForgotPasswordAlert(
              'success',
              'Sie erhalten in Kürze eine E-Mail zum Zurücksetzen Ihres Passworts.'
            )
            document
              .querySelectorAll('#ForgotPassword input, #ForgotPassword .btn')
              .forEach((elem) => (elem.style.display = 'none'))
          } else {
            showForgotPasswordAlert(
              'danger',
              'Es wurde kein passendes Konto gefunden.'
            )
          }
        })
        .catch(() => {
          showForgotPasswordAlert(
            'danger',
            'Es wurde kein passendes Konto gefunden.'
          )
        })
    })
  const forgotPasswordEl = document.querySelector(
    '#ForgotPassword'
  ) as HTMLElement
  const loginEl = document.querySelector('#Login') as HTMLElement
  document.querySelectorAll('a[href="/#ForgotPassword"]').forEach((link) => {
    link.addEventListener('click', function (e) {
      e.preventDefault()
      loginEl.style.display = 'none'
      forgotPasswordEl.style.display = 'block'
    })
  })

  document.querySelectorAll('a[href="/#Login"]').forEach((link) => {
    link.addEventListener('click', function (e) {
      e.preventDefault()
      loginEl.style.display = 'block'
      forgotPasswordEl.style.display = 'none'
    })
  })

  document.querySelectorAll('.start-trial').forEach((button) => {
    button.addEventListener('click', function (e) {
      e.preventDefault()
      startTrial().then(redirect).catch(showLoginError)
    })
  })
})

document.addEventListener('DOMContentLoaded', function () {
  const loginLink = document.querySelector('.is-login a')
  const loginWindow = document.querySelector('.login-window')

  if (!loginLink || !loginWindow) {
    return
  }
  // Attach click event to the .is-login a element
  loginLink.addEventListener('click', function (e) {
    e.preventDefault()
    e.stopPropagation()
    loginWindow.classList.add('is-active')
  })

  // Attach click event to the document
  document.addEventListener('click', function (e) {
    if (loginWindow.classList.contains('is-active')) {
      // Check if the click was outside the login window and the login link
      if (
        !loginWindow.contains(e.target as Node) &&
        !loginLink.contains(e.target as Node)
      ) {
        e.preventDefault()
        loginWindow.classList.remove('is-active')
      }
    }
  })
})
